import { en } from './locales/en';
import { es } from './locales/es';
import { is } from './locales/is';
import { pl } from './locales/pl';

export { namespaces, type LocaleResources, type Namespace } from './types';

export const resources = {
  en,
  is,
  pl,
  es,
} as const;

export type SupportedLocale = keyof typeof resources;
